import { render, staticRenderFns } from "./ScDetail.vue?vue&type=template&id=17ccd082"
import script from "./ScDetail.vue?vue&type=script&lang=js"
export * from "./ScDetail.vue?vue&type=script&lang=js"
import style0 from "./ScDetail.vue?vue&type=style&index=0&id=17ccd082&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports